module.exports = __webpack_public_path__ + "img/35.cfc4eadd.png";